var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lot-current-price',{attrs:{"lot":_vm.lot,"start-price-label":_vm.startPriceLabel,"current-price-label":_vm.currentPriceLabel,"winning-bid-label":_vm.winningBidLabel}})}
var staticRenderFns = []

export { render, staticRenderFns }